import React from 'react';
function Hero() {
    return (
         <div className='Container p-5 mb-5'>
            <div className='row text-center'>
                <img src="Media/images/homeHero.png" alt='Hero' className='mb-5'/>
                <h1 className='mt-5'>Invest in everything</h1>
                <p>Online platform to invest in stocks, derivatives, mutual funds, and more</p>
                <button className="p-2 btn btn-primary fs-5 mb-5" style={{width:"20%", margin:"0 auto"}}>Sign up</button>
            </div>
            
         </div>
    );
}

export default Hero;    